export const generateArticleCard = (articleRef) => ({
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    id: 'builder-d0dd4e159ffd46ab81d79824d2cb8cf6',
    component: {
        name: 'ArticleCard',
        options: {
            ctaText: 'Read Article',
            articleRef
        }
    },
    style: {
        width: '100%'
    }
})

export const articleCardDefault = {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    id: 'builder-d0dd4e159ffd46ab81d79824d2cb8cf6',
    component: {
        name: 'ArticleCard',
        options: {
            ctaText: 'Read Article',
            articleRef: {
                data: {
                    id: 'learn-ways-an-hsa-keeps-your-heart-healthy',
                    image: 'https://cdn.builder.io/api/v1/image/assets%2F481825b100e64e7f9a22a215d86e03f1%2Fd71d48f2d9d44c88b81760d2c035a59d',
                    page: {
                        '@type': '@builder.io/core:Reference',
                        id: '180bd60c9f7c4bd385661b06be0cf52c_94e70eae059a42e9a3d11f40e96359af',
                        model: 'learning-center-article-page',
                        value: {
                            data: {
                                description:
                                    'Heart disease is among the leading causes of death for both women and men in America. Using your Health Savings Account (HSA) is a great way to stay on top of your heart health',
                                title: 'Default Example Article Card',
                                url: '/'
                            },
                            name: 'Default Example Article Card'
                        }
                    },
                    title: 'Default Example Article Card'
                },
                id: '180bd60c9f7c4bd385661b06be0cf52c_d70b299632124f6a975647e710b8e881',
                modelId: '180bd60c9f7c4bd385661b06be0cf52c_2286599b6bb64a2b82530437e3bd1976',
                name: 'learn-ways-an-hsa-keeps-your-heart-healthy'
            }
        }
    }
}
